import React from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';

import { getMessage } from 'util/locale';

import { connectToAffiliate } from 'affiliates';
import { closeConnectToAffiliateModal } from 'current/uiwidgets';
import { getConnectToAffiliateModal } from 'current/selectors';

// components
import BaseModal from 'common/modals/BaseModal';

const baseString = 'vra-connect-affiliate-modal';
let ConnectToAffiliateModalContainer = ({
  affiliateId,
  onCancelConnectToAffiliateModal,
  onSaveConnectToAffiliateModal
}) => affiliateId ? (
  <BaseModal
    header={getMessage(`title-text__connection--${affiliateId}`)}
    onCancel={() => { onCancelConnectToAffiliateModal(); }}
    onSave={() => { onSaveConnectToAffiliateModal({ affiliateId }); }}
    saveText={getMessage('button-text__affirmative')}>

    <section className={`${baseString}__body`}>
      {getMessage(`text__connection--${affiliateId}`)}
    </section>

  </BaseModal>
) : null;

ConnectToAffiliateModalContainer.propTypes = {
  affiliateId: propTypes.string,
  onCancelConnectToAffiliateModal: propTypes.func.isRequired,
  onSaveConnectToAffiliateModal: propTypes.func.isRequired
};

ConnectToAffiliateModalContainer = connect(
  (state) => {
    return {
      affiliateId: getConnectToAffiliateModal(state)
    };
  },
  (dispatch) => {
    return {
      onCancelConnectToAffiliateModal: () => dispatch(closeConnectToAffiliateModal()),
      onSaveConnectToAffiliateModal: ({ affiliateId }) => {
        dispatch(connectToAffiliate({ affiliateId }));
      }
    };
  }
)(ConnectToAffiliateModalContainer);
export default ConnectToAffiliateModalContainer;
